import { Category } from '@/types';
import { toast } from 'sonner';

export const moveCategory = (
  categories: Category[],
  categoryId: string,
  parentId: string | null,
  direction: 'up' | 'down'
): Category[] => {
  console.log('Moving category:', {
    categoryId,
    parentId,
    direction,
    categoriesLength: categories.length,
    categories
  });

  // Function to update the order of categories in an array
  const updateCategoriesOrder = (cats: Category[]): Category[] => {
    const index = cats.findIndex(c => c.id === categoryId);
    console.log('Found category at index:', index);

    if (index === -1) return cats;

    const newCategories = [...cats];
    
    if (direction === 'up' && index > 0) {
      // Store the categories to swap
      const temp = newCategories[index];
      newCategories[index] = newCategories[index - 1];
      newCategories[index - 1] = temp;

      // Update sort orders
      newCategories.forEach((cat, idx) => {
        cat.sortOrder = idx + 1;
      });

      console.log('Categories after moving up:', newCategories);
      return newCategories;
    } else if (direction === 'down' && index < cats.length - 1) {
      // Store the categories to swap
      const temp = newCategories[index];
      newCategories[index] = newCategories[index + 1];
      newCategories[index + 1] = temp;

      // Update sort orders
      newCategories.forEach((cat, idx) => {
        cat.sortOrder = idx + 1;
      });

      console.log('Categories after moving down:', newCategories);
      return newCategories;
    }

    return cats;
  };

  // Function to recursively find and update nested categories
  const updateNestedCategories = (cats: Category[], targetParentId: string): Category[] => {
    return cats.map(cat => {
      if (cat.id === targetParentId) {
        return { ...cat, children: updateCategoriesOrder(cat.children) };
      }
      if (cat.children.length > 0) {
        return { ...cat, children: updateNestedCategories(cat.children, targetParentId) };
      }
      return cat;
    });
  };

  // If we're dealing with top-level categories (parentId is null)
  if (!parentId) {
    console.log('Moving top-level category');
    return updateCategoriesOrder(categories);
  }

  // Handle nested categories at any level
  console.log('Moving nested category with parentId:', parentId);
  return updateNestedCategories(categories, parentId);
};